<!-- item.html -->
@if (selector()) {
<label>
  <div
    class="cursor-pointer w-full bg-base-100 border border-gray-200 rounded-lg shadow-sm hover:bg-gray-100 p-6 flex items-start gap-6">
    <input
      data-testid="test-set-item"
      [id]="id()"
      type="checkbox"
      [name]="name()"
      class="size-8 md:size-6 bg-base-100 border-text-disabled rounded-lg mt-8 checkbox checkbox-neutral"
      [checked]="isSelected()"
      (change)="selectItem.emit(id()!)"
      (keydown.enter)="$event.preventDefault()" />
    <div class="flex-1 flex flex-col justify-between min-h-full">
      <div class="flex sm:flex-row flex-col justify-between w-full">
        <div class="flex flex-col gap-1 flex-1">
          <app-badge [value]="difficulty()!" [size]="'sm'" />
          <h5 class="lg:text-xl text-lg font-bold text-gray-900">
            {{ title() }}
          </h5>
        </div>
        <div class="text-sm text-gray-500">{{ duration() }} minutes</div>
      </div>
      <p class="w-full mt-2 text-gray-600 text-sm truncate-2-lines">
        {{ stripHtmlTags(description()!) }}
      </p>
    </div>
  </div>
</label>
} @else {
<div
  class="cursor-pointer w-full bg-base-100 border border-gray-200 rounded-lg shadow-sm p-6 flex items-start gap-6">
  <div class="flex-1 flex flex-col justify-between min-h-full">
    <div class="flex flex-col sm:flex-row items-start justify-between w-full">
      <div class="flex flex-col gap-1 flex-1">
        <app-badge [value]="difficulty()!" [size]="'sm'" />
        <h5 class="lg:text-xl text-lg font-bold text-gray-900">
          {{ title() }}
        </h5>
      </div>
      <div class="text-sm text-gray-500">{{ duration() }} minutes</div>
    </div>
    <p class="w-full mt-2 text-gray-600 text-sm truncate-2-lines">
      {{ stripHtmlTags(description()!) }}
    </p>
  </div>
</div>
}
